import React from 'react';
import { useForm } from 'react-hook-form';
import { apiConnector } from '../../services/apiconnector';
import { contactusEndpoint } from '../../services/apis';
import CountryCode from '../../data/countrycode.json';

const ContactForm = ({ setConfirmationModal }) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const submitContactForm = async (data) => {
        try {
            setConfirmationModal({
                text1: `Hello ${data.firstName}`,
                text2: "Thanks for reaching out. We'll be in touch soon.",
                closeModal: () => setConfirmationModal(null)
            })
            reset({
                email: '',
                firstName: '',
                lastName: '',
                message: '',
                phoneNo: '',
            })
            await apiConnector("POST", contactusEndpoint.CONTACTUS_API, data);
        } catch (error) {
            console.log('ContactUs API Call failed => ', error.message);
        }
    }

    return (
        <div>
            <form onSubmit={handleSubmit(submitContactForm)} className='w-full flex flex-col md:gap-y-4 gap-y-6'>
                <div className='flex md:flex-row flex-col gap-x-4 md:gap-y-0 gap-y-6'>
                    <label className='w-full'>
                        <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>First Name <sup className='text-pink-200'>*</sup></p>
                        <input
                            className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            type='text'
                            placeholder='Enter First Name'
                            name='firstName'
                            id='firstName'
                            {...register("firstName", { required: true })}
                        />
                        {errors.firstName && (
                            <span className='text-pink-500 text-sm'>Please enter your name</span>
                        )}
                    </label>
                    <label className='w-full'>
                        <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Last Name</p>
                        <input
                            className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            type='text'
                            placeholder='Enter Last Name'
                            name='lastName'
                            id='lastName'
                            {...register("lastName")}
                        />
                    </label>
                </div>
                <label>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Email <sup className='text-pink-200'>*</sup></p>
                    <input
                        className='p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        type='email'
                        placeholder='Enter Email Address'
                        name='email'
                        id='email'
                        {...register("email", { required: true })}
                    />
                    {errors.email && (<span className='text-pink-500 text-sm'>Please enter your Email</span>)}
                </label>
                <label htmlFor='phoneNo'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Phone Number <sup className='text-pink-200'>*</sup></p>
                    <div className='flex items-center gap-x-3'>
                        <select
                            className='p-[12px] bg-richblack-800 rounded-[0.5rem] w-[5rem] text-richblack-5 outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            name='dropdown'
                            id='dropdown'
                            {...register("countryCode", { required: true })}
                        >
                            {CountryCode.map((code, index) => {
                                return (
                                    <option key={index} value={code.code}>
                                        {code.code} - {code.country}
                                    </option>
                                )
                            })}
                        </select>
                        <div className='relative flex w-full'>
                            <input
                                className='p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full outline-none'
                                style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                type='number'
                                placeholder='12345 67890'
                                name='phoneNo'
                                id='phoneNo'
                                {...register("phoneNo",
                                    {
                                        required: { value: true, message: 'Please enter your Phone Number' },
                                        maxLength: { value: 10, message: 'Invalid Phone Number' },
                                        minLength: { value: 8, message: 'Invalid Phone Number' },
                                    }
                                )}
                            />
                            {errors.phoneNo && (<span className='text-pink-500 text-sm absolute -bottom-6'>{errors.phoneNo.message}</span>)}
                        </div>
                    </div>
                </label>
                <label>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Message <sup className='text-pink-200'>*</sup></p>
                    <textarea
                        className='p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full h-[12rem] outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        name='message'
                        id='message'
                        placeholder="Share your thoughts, dreams, and ideas with us!"
                        {...register("message", { required: true })}
                    />
                    {errors.message && (<span className='text-pink-500 text-sm'>Please enter a Message</span>)}
                </label>
                <button className='bg-yellow-50 py-[8px] px-[12px] hover:scale-95 transition-all duration-200 rounded-[8px] my-2 font-medium text-richblack-900' type='submit'>Send Message</button>
            </form>
        </div>
    )
}

export default ContactForm;